import React, { memo } from 'react';

const SageIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
            <rect width={24} height={24} fill="#000" rx={6} />
            <path fill="#00D639" d="M15.5 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" />
            <path
                fill="#fff"
                d="M11 16.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM20 16.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
            />
        </svg>
    );
};

export default memo(SageIcon);
